import { Card, Select } from "antd";
import React from "react";
import LineChart from "./LineChart";

const RevenueChart = (props: any) => {
  const handleFilterChange = (value: string) => {
    props.onFilterChange(value);
    props.setName("left");
  };

  return (
    <div>
      <Card className="chart_card">
        <div
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <h2 style={{ margin: 0, fontSize: 19 }}>Revenue Generated</h2>
          <div style={{ width: "20%" }}>
            <Select
              style={{ width: "100%" }}
              onChange={handleFilterChange}
              defaultValue={"monthly"}
              placeholder="Filter"
              options={[
                { value: "daily", label: "Daily" },
                { value: "weekly", label: "Weekly" },
                { value: "monthly", label: "Monthly" },
                { value: "yearly", label: "Yearly" },
              ]}
            />
          </div>
        </div>
        <div style={{ margin: "auto" }} className="graph_ch">
          <LineChart data={props.graphData} />
        </div>
      </Card>
    </div>
  );
};

export default RevenueChart;
